































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Action, Getter, State } from 'vuex-class'
import { TextFormatting } from '../../mixins/TextFormatting'

@Component({
  name: 'productCard-standard',
  mixins: [TextFormatting],
})
export default class productCardStandard extends Vue {
  @Prop({ default: null }) product: any

  private cssPropertyComponent = 'productCard'

  get formattedButtonLabel() {
    const searchMask = '{price}'
    const regEx = new RegExp(searchMask, 'ig')

    const replaceMask = this.$options.filters?.currency(this.product.ProductPrice.PriceValue, '$', 0)

    return this.buttonLabel.replace(regEx, replaceMask)
  }

  private selectCard() {
    window.dispatchEvent(new CustomEvent('product:selected', { detail: { Id: this.product.Id } }))

    this.$emit('card-selected', this.product)
  }

  get buttonLabel(): string {
    const buttonLabel = document.body.style.getPropertyValue(`--${this.cssPropertyComponent}-buttonLabel`)
    return buttonLabel || 'Shop Now'
  }

  get elevation(): number {
    const elevationSetting: string = document.body.style.getPropertyValue(`--${this.cssPropertyComponent}-elevation`)
    return Number.parseInt(elevationSetting) || 0
  }

  get imageHeight(): number {
    const imageHeightSetting: string = document.body.style.getPropertyValue(
      `--${this.cssPropertyComponent}-imageHeight`
    )
    return Number.parseInt(imageHeightSetting) || 200
  }

  get showImage(): boolean {
    const showImageSetting: string = document.body.style.getPropertyValue(`--${this.cssPropertyComponent}-showImage`)
    return !!(showImageSetting && showImageSetting == 'true')
  }

  get showTitleOverImage(): boolean {
    const showTitleOverImageSetting: string = document.body.style.getPropertyValue(
      `--${this.cssPropertyComponent}-showTitleOverImage`
    )
    return !!(showTitleOverImageSetting && showTitleOverImageSetting == 'true')
  }

  get showPriceDivider(): boolean {
    const showPriceDividerSetting: string = document.body.style.getPropertyValue(
      `--${this.cssPropertyComponent}-showPriceDivider`
    )
    return !!(showPriceDividerSetting && showPriceDividerSetting == 'true')
  }

  get showPrices(): boolean {
    const showPricesSetting: string = document.body.style.getPropertyValue(`--${this.cssPropertyComponent}-showPrices`)
    return !!(showPricesSetting && showPricesSetting == 'true')
  }

  get showButton(): boolean {
    const showButtonSetting: string = document.body.style.getPropertyValue(`--${this.cssPropertyComponent}-showButton`)
    return !!(showButtonSetting && showButtonSetting == 'true')
  }

  get showTitleDivider(): boolean {
    const showTitleDividerSetting: string = document.body.style.getPropertyValue(
      `--${this.cssPropertyComponent}-showTitleDivider`
    )
    return !!(showTitleDividerSetting && showTitleDividerSetting == 'true')
  }
}
